import { fetchStrapi } from './strapi';

export interface LegalSection {
  title: string;
  content: string;
}

export interface Impressum {
  title: string;
  sections: LegalSection[];
}

export async function fetchImpressum(): Promise<Impressum | null> {
  try {
    const response = await fetchStrapi<any>('/impressum?populate=*');

    if (!response.data) {
      return null;
    }

    const data = response.data;

    return {
      title: data.titel || '',
      sections: (data.abschnitte || []).map((s: any) => ({
        title: s.titel || '',
        content: s.inhalt || '',
      })),
    };
  } catch (error) {
    console.error('Error fetching impressum from Strapi:', error);
    return null;
  }
}
